import { isStanbridgeClient } from '@/composables/useEdverumClient.js';

/** Global roles that author System Alerts (epic Q5); mirrors the server's SystemAlertPolicy (`User::isAdmin()`). */
export const SYSTEM_ALERT_AUTHOR_ROLES = Object.freeze(['Owner', 'Admin', 'Instruction Admin']);

/** EdverumFeature case name of the ADR-036 pilot flag that gates the Dashboards authoring UI (H9). */
export const SYSTEM_ALERTS_AUTHORING_FEATURE = 'SYSTEM_ALERTS_AUTHORING';

/**
 * Navigation projection only: decides whether the Dashboards card and admin routes are offered.
 * The authoring API authorizes every request independently.
 *
 * @param {object|null|undefined} user Vuex-ORM User from the auth store.
 * @returns {boolean}
 */
export function canAuthorSystemAlerts(user) {
    if (!isStanbridgeClient() || !user) {
        return false;
    }

    // Optional calls: this also runs inside the shared /dashboards check, which must fail closed, not throw.
    return (
        !!user.hasAnyRole?.(SYSTEM_ALERT_AUTHOR_ROLES) &&
        !!user.hasActiveFeature?.(window.__INITIAL_STATE__?.Features?.[SYSTEM_ALERTS_AUTHORING_FEATURE])
    );
}
